import { render, staticRenderFns } from "./RestricoesCashback.vue?vue&type=template&id=8414378c&scoped=true"
import script from "./RestricoesCashback.vue?vue&type=script&lang=js"
export * from "./RestricoesCashback.vue?vue&type=script&lang=js"
import style0 from "./RestricoesCashback.vue?vue&type=style&index=0&id=8414378c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8414378c",
  null
  
)

export default component.exports